import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'

const LogoContainer = () => {
    const location = useLocation()
    const isHomePage = location.pathname === '/'
    const { i18n } = useTranslation()

    // Geçerli dili al
    const currentLang = i18n.language

    // Ana sayfa ve dil bazlı logo seçimi
    const getLogoSrc = () => {
        if (isHomePage) {
            if (currentLang === 'tr') return '/images/logo-white.svg'
            if (currentLang === 'en') return '/images/en-logo-white.svg'
            return '/images/white-logo.svg'
        } else {
            if (currentLang === 'tr') return '/images/logo.svg'
            if (currentLang === 'en') return '/images/en-logo.svg'
            return '/images/logo.svg'
        }
    }

    return (
        <div className='hidden md:grid grid-cols-14 h-28 md:h-40 absolute w-[calc(100vw-2.5rem)] md:w-[calc(100vw-7rem)] top-0 left-0 z-50'>
            <div className={`col-start-2 col-span-13 ${isHomePage ? 'md:mb-0' : 'md:mb-9'}`}>
                <motion.div
                    key={getLogoSrc()}
                    initial={{ opacity: 0, x: isHomePage ? 50 : -50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5 }}
                    exit={{ opacity: 0, x: isHomePage ? 50 : -50 }}
                    className={`w-full h-full flex justify-start items-end ${!isHomePage ? 'pr-16' : ''}`}
                >
                    <Link to={'/'}>
                        <img
                            src={getLogoSrc()}
                            className='w-48 md:w-72 pb-6 md:pb-0 relative z-50'
                            alt="Logo"
                        />
                    </Link>
                </motion.div>
            </div>
        </div>
    )
}

export default LogoContainer
